import {Injectable} from '@angular/core';
import {ofType} from 'redux-observable';
import {ApplicationProjectTypeActions} from '../Actions/application-project-types-actions';
import {ApplicationCatalogActions} from "../Actions/application-catalog-actions";
import {IProjectTypeSelector} from "../../models/common";
import {HttpClient} from "@angular/common/http";
import {catchError, filter, map, mergeMap, tap} from "rxjs/operators";
import {combineLatest, from, Observable, of} from "rxjs";
import {ActionLocal} from "../Actions/actions.service";
import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import {ApplicationToolbarActions} from "../Actions/application-toolbar-actions";
import {APP_CONFIG_STATE_INIT, IAppCatalog, IAppConfig} from "../selector.state";
import {ApplicationConfigActions} from "../Actions/application-config-actions";

@Injectable()
export class LoadProjectTypesEpics {
  constructor(private http: HttpClient) {
  }

  private _loadApplicationSelectorMenu() {
    const a = this.http.get('assets/catalogs/eds_project_types.json', {responseType: 'json'});
    const b = this.http.get('/assets/eds-config.json', {responseType: 'json'}).pipe(
      map((x: IAppConfig) => ({...APP_CONFIG_STATE_INIT, ...x})),           // load parameter and merge with default
      catchError(() => of(APP_CONFIG_STATE_INIT)),
      tap(x => edsEnvConfiguration.updateConfiguration(x)),        // update the edsEnvConfiguration to avoid different compilation
    );
    return combineLatest([a, b]).pipe(
      map(([x, y]) => ({topologies: x as IProjectTypeSelector[], config: y})),
    );
  }

  private _loadApplicationTypeMap(): Observable<any> {
    return this.http.get('assets/catalogs/eds_app_types_map.json', {responseType: 'json'});
  }


  loadProjectTypes = (action$) => {
    return action$.pipe(
      ofType(ApplicationProjectTypeActions.ActionType.LOAD),
      mergeMap(() => {
        return this._loadApplicationSelectorMenu().pipe(
          mergeMap(({topologies, config}) => [ApplicationProjectTypeActions.loadedProjectTypes(topologies), ApplicationConfigActions.setConfiguration(config)]),
          catchError((error: Response) => of(ApplicationProjectTypeActions.loadedError(error ? error.toString() : "Load project type error unknown")))
        );
      })
    );
  }

  loadAppTypesMap = (action$) => {
    // the app types map must be load at catalog loading...
    const listeningAction: string[] = [
      ApplicationProjectTypeActions.ActionType.LOAD,
      ApplicationCatalogActions.ActionType.LOAD
    ];
    return action$.pipe(
      filter((x: ActionLocal) => listeningAction.includes(x.type)),
      mergeMap(() => {
        return this._loadApplicationTypeMap().pipe(
          map(appTypeMAp => (ApplicationProjectTypeActions.loadedAppTypesMap(appTypeMAp))),
          catchError((error: Response) => of(ApplicationProjectTypeActions.loadedAppTypesMapError(error.toString())))
        );
      })
    );
  }

  updateBreadCrumbs = (action$) => {
    // return {type: ApplicationCatalogActions.ActionType.LOAD, payload: {appClass:appClass, name:catalogName,  topologiesFilter:topologies}};
    const prjTypeLoad = action$.pipe(ofType(ApplicationProjectTypeActions.ActionType.LOADED));
    const catLoad = action$.pipe(ofType(ApplicationCatalogActions.ActionType.LOAD));
    return combineLatest([prjTypeLoad, catLoad]).pipe(
      mergeMap(([prj, cat]) => {
        const breadCrumb = [];
        const rootMenu = (prj as ActionLocal).payload as IProjectTypeSelector[];
        const appCatalog = (cat as ActionLocal).payload as IAppCatalog;
        // Added a level in the menu to access the application
        let tmpRoot = null;
        if (rootMenu.length > 0) {
          tmpRoot = rootMenu[0].nodes.find(x => x.nodes && x.nodes.find(y => y.classType === appCatalog.appClass && y.catalog === appCatalog.name)); // converter
          if (!tmpRoot && rootMenu.length > 1) {
            tmpRoot = rootMenu[1].nodes.find(x => x.nodes && x.nodes.find(y => y.classType === appCatalog.appClass && y.catalog === appCatalog.name)); // led
          }
        }

        if (tmpRoot) {
          const subRoot = {...tmpRoot, nodes: tmpRoot.nodes.filter(x => x.classType === appCatalog.appClass && x.catalog === appCatalog.name)};
          breadCrumb.push(subRoot); // root
          const subMenu = subRoot.nodes.find(x => x.classType === appCatalog.appClass && x.catalog === appCatalog.name); // dcdc or acdc
          this.addItemInBreadCrumb(subMenu, appCatalog.topologiesFilter, breadCrumb);
        }
        // reset search string on load catalog
        return from([ApplicationProjectTypeActions.setBreadCrumbItems(breadCrumb), ApplicationToolbarActions.setSearch('')]);
      })
    );
  }

  addItemInBreadCrumb(subMenu: IProjectTypeSelector, filterTopology: string[], bC: IProjectTypeSelector[]) {
    if (subMenu) {
      bC.push(subMenu);

      if (filterTopology.length > 0) {
        if (subMenu.nodes && subMenu.nodes.length > 0) {
          // const findSub =  subMenu.nodes.find(x => x.filterTopologies.every(y => filter.includes(y)));
          const findSub = subMenu.nodes.find(x => filterTopology.every(y => x.filterTopologies && x.filterTopologies.includes(y)));
          this.addItemInBreadCrumb(findSub, filterTopology, bC);
        }
      }
    }
  }

}

